import { Modal, Text, Box } from '@marketmuse/components';
import {
  useStoreDispatch,
  useStoreSelector,
} from '@marketmuse/data-state/hooks';
import { MISC_SIMPLE_KEYS } from '@marketmuse/data-state';
import { miscActions } from '@marketmuse/data-state/misc';
import { SubscriptionUpsellContent } from '../components/SubscriptionUpsellContent';
import { SubscriptionPackages } from './SubscriptionPackages';

const ExpiredNonTrialModal = () => {
  const dispatch = useStoreDispatch();
  const subscription = useStoreSelector(state => state.payment.subscription);
  const siteId = useStoreSelector(state => state.filter?.site?.id);

  const isPlgDisabled = process.env.REACT_APP_ENABLE_PLG_FLOW !== 'true';

  return (
    <Modal
      isVisible={true}
      onClose={() => {
        // do nothing
      }}
      disableClose={true}
      closeBtnClassName={['hidden']}
      panelClassName={['w-fit', 'max-w-fit', 'p-10']}
    >
      {!isPlgDisabled && (
        <Box>
          <Box className={['prose', 'mb-4']}>
            <Text as="h1" className={['text-2xl', 'mb-2']}>
              Reactivate your MarketMuse account
            </Text>
            <Text as="p">
              Your account has expired, or been terminated. Downgrade to free
              for limited access, or reactivate on any of our plans.
            </Text>
          </Box>
          <SubscriptionPackages
            subscriptionId={subscription?.id || ''}
            siteId={siteId || ''}
            wrapperClassNames={[
              'flex',
              'flex-row',
              'gap-10',
              'w-full',
              'justify-center',
            ]}
            cardClassNames={['w-[320px]']}
            dataTags={{
              ctaUpgrade: {
                'data-mms--subscription-canceled-action': 'upgrade',
              },
              ctaDowngrade: {
                'data-mms--subscription-canceled-action': 'exit-to-free',
              },
            }}
          />
        </Box>
      )}
      {isPlgDisabled && (
        <SubscriptionUpsellContent
          disclaimer="Your subscription has expired, or been terminated."
          ctaAttrs={{
            'data-mms--subscription-canceled-action': 'book-demo',
          }}
          handleBookDemo={() =>
            dispatch(
              miscActions.setSimple({
                key: MISC_SIMPLE_KEYS.salesUpsellMotion,
                value: true,
              }),
            )
          }
        />
      )}
    </Modal>
  );
};
export default ExpiredNonTrialModal;
